import {
  Component,
  inject,
  TemplateRef,
  ViewChild,
  model,
  ElementRef,
  signal,
} from "@angular/core";
import { FormBuilder, FormsModule, ReactiveFormsModule } from "@angular/forms";
import { DrawerItem } from "@progress/kendo-angular-layout";
import { items } from "../items";
import { MenuNode } from "../reordering";
import { EmployeeEditService } from "../employee-edit.service";
import { Employee } from "../../model/employee";
import { HostListener } from "@angular/core";
import { MenuService } from "../../services/menu.services";
import {
  AddEvent,
  CellClickEvent,
  EditEvent,
  KENDO_TREELIST,
  RowClassArgs,
  RowReorderEvent,
  SaveEvent,
  TreeListComponent,
} from "@progress/kendo-angular-treelist";
import { NotificationService } from "@progress/kendo-angular-notification";
import { take } from "rxjs/operators";
import { CustomMessagesService } from "../../services/custom-messages.service";
import { KENDO_ICON, KENDO_SVGICON } from "@progress/kendo-angular-icons";
import { TicketPrices } from "../../data/models/interfaces";
import { MenuDownloadService } from "../../services/menu.download.services";
import { ConfirmationDeleteComponent } from "../../window/confirmation-delete/confirmation-delete.component";
import { ViewItem } from "../../model/view-item";
import { KENDO_BUTTON } from "@progress/kendo-angular-buttons";
import { KENDO_INPUTS } from "@progress/kendo-angular-inputs";
import { MenuReorderingService } from "../../services/menu.reordering.services";
import { IconComponent } from "../../window/icon/icon.component";
import { insertMiddleIcon, SVGIcon } from "@progress/kendo-svg-icons";
import { FirstLinePipe } from "../../pipes/first-line.pipe";
import { ImpressionService } from "../../services/impression.service";

@Component({
  selector: "app-mode-reordering",
  imports: [
    ReactiveFormsModule,
    KENDO_TREELIST,
    ConfirmationDeleteComponent,
    KENDO_BUTTON,
    KENDO_INPUTS,
    FormsModule,
    IconComponent,
    KENDO_ICON,
    KENDO_SVGICON,
    FirstLinePipe,
  ],
  providers: [EmployeeEditService],
  templateUrl: "./mode-reordering.component.html",
  styleUrls: ["./mode-reordering.component.css"],
})
export class ModeReorderingComponent {
  protected readonly customMessagesService = inject(CustomMessagesService);
  readonly menuService = inject(MenuService);
  readonly menuDownloadService = inject(MenuDownloadService);
  readonly menuReorderingService = inject(MenuReorderingService);
  readonly expandable = model<boolean>(true);
  readonly expandedDrawerIds = model<number[]>([]);

  // TODO a garder en mémoire pour du plus complexe
  private formBuilder = inject(FormBuilder);
  private readonly notificationService = inject(NotificationService);
  private readonly editService = inject(EmployeeEditService);

  @ViewChild("editNameInput")
  private editNameInput?: ElementRef<HTMLInputElement>;

  public dragIcon: SVGIcon = insertMiddleIcon;

  constructor() {
    this.menuService.ensureSelectedMenuItem();
  }
  //--------------------------------------------------------------------------------------------------------------------

  swSauver = false;

  @HostListener("window:beforeunload", ["$event"])
  unloadNotification($event: BeforeUnloadEvent): void {
    if (!this.swSauver) {
      $event.preventDefault();
      $event.returnValue = "";
    }
  }

  @ViewChild("notificationTemplate", { read: TemplateRef })
  public notificationTemplate!: TemplateRef<unknown>;

  // Edit
  // public formGroup: FormGroup;
  public editedItem: Employee | undefined;
  // End Edit

  protected readonly swDebug = false;

  public items: DrawerItem[] = items;

  public expandedIds: number[] = [1, 2, 7];
  public selectedRowId?: number;

  // Icon window
  public selectedIconId = signal<number>(0);
  public selectedLabelIcon = signal<string>("");

  private ticketPrices: TicketPrices = {
    fullPackage: 510,
    workshopFirstDay: 200,
    workshopSecondDay: 250,
    talksOnly: 150,
    onlineTickets: 80,
  };

  public submitForm(): void {
    // this.excelDataService.saveTicketData(this.formGroup.value);
    this.notificationService.show({
      content: this.notificationTemplate,
      cssClass: "button-notification",
      hideAfter: 1300,
      animation: { type: "slide", duration: 400 },
      position: { horizontal: "center", vertical: "top" },
      type: { style: "success", icon: true },
    });
  }

  public clearForm(): void {
    /*this.formGroup.reset({
      fullPackage: 0,
      workshopFirstDay: 0,
      workshopSecondDay: 0,
      talksOnly: 0,
      onlineTickets: 0,
    });*/
  }

  public calculateTotalPrice(): number {
    /*
    const values = this.formGroup.value;
    const totalPrice =
      values["fullPackage"] * this.ticketPrices["fullPackage"] +
      values["workshopFirstDay"] * this.ticketPrices["workshopFirstDay"] +
      values["workshopSecondDay"] * this.ticketPrices["workshopSecondDay"] +
      values["talksOnly"] * this.ticketPrices["talksOnly"] +
      values["onlineTickets"] * this.ticketPrices["onlineTickets"];
    return totalPrice;
    */
    return 0;
  }

  public calculateTicketPrice(ticketType: keyof TicketPrices): string {
    return this.ticketPrices[ticketType].toFixed(2);
  }

  public getVisibleIds(): number[] {
    const result: number[] = [];

    const addVisibleChildren = (parentId: number | null): void => {
      const children = this.menuService
        .node()
        .filter((item) => item.parentId === parentId);

      for (const child of children) {
        result.push(child.archiveId);

        if (this.expandedIds.includes(child.archiveId)) {
          addVisibleChildren(child.archiveId);
        }
      }
    };

    addVisibleChildren(null);

    return result;
  }

  public addHandler({ sender, parent }: AddEvent): void {
    // Close the current edited row, if any.
    this.closeEditor(sender);

    // Expand the parent.
    if (parent) {
      sender.expand(parent);
    }

    // Define all editable fields validators and default values
    /*
    this.formGroup = new FormGroup({
      ReportsTo: new FormControl(parent ? parent.archiveId : null),
      FirstName: new FormControl("", Validators.required),
      LastName: new FormControl("", Validators.required),
      Position: new FormControl(""),
      Extension: new FormControl(
        "",
        Validators.compose([Validators.required, Validators.min(0)]),
      ),
    });

    // Show the new row editor, with the `FormGroup` build above
    sender.addRow(this.formGroup, parent);
    */
    sender.addRow({}, parent);
  }

  public editHandler({ sender, dataItem }: EditEvent): void {
    // Close the current edited row, if any.
    this.closeEditor(sender, dataItem);

    // Define all editable fields validators and default values
    /*
    this.formGroup = new FormGroup({
      archiveId: new FormControl(dataItem.archiveId),
      ReportsTo: new FormControl(dataItem.ReportsTo),
      FirstName: new FormControl(dataItem.FirstName, Validators.required),
      LastName: new FormControl(dataItem.LastName, Validators.required),
      Position: new FormControl(dataItem.Position),
      Extension: new FormControl(
        dataItem.Extension,
        Validators.compose([Validators.required, Validators.min(0)]),
      ),
    });*/

    this.editedItem = dataItem;

    // Put the row in edit mode, with the `FormGroup` build above
    //sender.editRow(dataItem, this.formGroup);
    sender.editRow(dataItem, {});
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  public cancelHandler({ sender, dataItem, isNew }: CancelEvent): void {
    // Close the editor for the given row
    this.closeEditor(sender, dataItem, isNew);
  }

  public saveHandler({
    sender,
    dataItem,
    parent,
    formGroup,
    isNew,
  }: SaveEvent): void {
    // Collect the current state of the form.
    // The `formGroup` argument is the same as was provided when calling `editRow`.
    const employee: Employee = formGroup.value;

    if (!isNew) {
      // Reflect changes immediately
      Object.assign(dataItem, employee);
    } else if (parent) {
      // Update the hasChildren field on the parent node
      parent.hasChildren = true;
    }

    this.editService
      // Publish the update to the remote service.
      .save(employee, parent, isNew)
      .pipe(take(1))
      .subscribe(() => {
        if (parent) {
          // Reload the parent node to reflect the changes.
          sender.reload(parent);
        }
      });

    sender.closeRow(dataItem, isNew);
  }

  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  public removeHandler({ sender, dataItem, parent }: RemoveEvent): void {
    this.editService
      // Publish the update to the remote service.
      .remove(dataItem, parent)
      .pipe(take(1))
      .subscribe(() => {
        if (parent) {
          // Reload the parent node to reflect the changes.
          sender.reload(parent);
        }
      });
  }

  private closeEditor(
    treelist: TreeListComponent,
    dataItem: unknown = this.editedItem,
    isNew = false,
  ): void {
    treelist.closeRow(dataItem, isNew);
    this.editedItem = undefined;
    // this.formGroup = undefined;
  }

  protected readonly console = console;

  public addChild(id: number): void {
    console.log(id);
  }

  public onRowReorder(event: RowReorderEvent): void {
    console.log(event);
    setTimeout(() => {
      this.menuService.setMenuNode(this.menuService.node());
      console.log("data après reorder: ", this.menuService.node());
    });
    /*
    setTimeout(() => {
      localStorage.setItem(
        "treeState",
        JSON.stringify({
          data: this.data,
          expandedIds: this.expandedIds,
        }),
      );

      console.log("data après reorder: ", this.data);

      // this.refreshDrawer();
      this.drawerItems = [...this.getItems()];
      this.menuService.setMenu(this.getItems());
      // this.expandedDrawerIds = [...this.getParentIds()];
    });*/
  }

  public onCellClick(event: CellClickEvent): void {
    const dataItem = event.dataItem as MenuNode;

    this.selectedRowId = dataItem.archiveId;

    console.log("Ligne cliquée :", dataItem);
    console.log("ID cliqué :", dataItem.archiveId);
  }

  public downloadYaml(fileName = "menu.yaml"): void {
    const blob = new Blob([this.menuDownloadService.yaml()], {
      type: "text/yaml;charset=utf-8",
    });

    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");

    link.href = url;
    link.download = fileName;
    link.click();

    URL.revokeObjectURL(url);
  }

  public swConfirmationDeleteOpen = false;
  public msgConfirmationDelete = "?";
  public idConfirmationDelete = 0;
  public childConfirmationDelete = 0;

  public swIconListOpen = false;
  public msgIconList = "?";

  confirmationDelete(data: ViewItem, type: string) {
    // console.log(data);
    // console.log(data.id);
    this.idConfirmationDelete = data.id;
    this.childConfirmationDelete = this.menuService.countChildren(
      this.idConfirmationDelete,
    );
    if (!data.hasChildren) {
      this.msgConfirmationDelete = type;
    } else {
      this.msgConfirmationDelete = data.data.name;
    }
    this.swConfirmationDeleteOpen = true;
  }

  onClosedConfirmationDelete(result: boolean): void {
    if (result) {
      this.menuService.removeMenuNode(this.idConfirmationDelete);
    }
    this.swConfirmationDeleteOpen = false;
  }

  //--------------------------------------------------------------------------------------------------------------------

  public rowCallback = (context: RowClassArgs) => {
    if (context.dataItem.type !== "") {
      return {};
    }

    const years: number = context.dataItem.yearsExperience;
    const isSelected: boolean = context.dataItem.isSelected;

    return {
      isSelected: isSelected,
      senior: years >= 15,
      experienced: years >= 5 && years < 15,
      resident: years < 5,
    };
  };

  //--------------------------------------------------------------------------------------------------------------------

  public startEdit(id: number): void {
    this.menuReorderingService.setSwEditTrue(id);

    setTimeout(() => {
      this.editNameInput?.nativeElement.focus();
      this.editNameInput?.nativeElement.select();
    });
  }

  //--------------------------------------------------------------------------------------------------------------------

  public onClosedSelectIcon(): void {
    this.swIconListOpen = false;
  }

  //--------------------------------------------------------------------------------------------------------------------

  private impression = inject(ImpressionService);
  enCours = false;

  exportPdf() {
    this.enCours = true;

    this.impression.telechargerVides().subscribe({
      error: (err) => {
        this.enCours = false;
        console.error("Fusion échouée", err);
      },
      complete: () => (this.enCours = false),
    });
  }

  exportPdfAvecUnit() {
    this.enCours = true;

    this.impression.telechargerVidesUnit(this.menuService.node()).subscribe({
      error: (err) => {
        this.enCours = false;
        console.error("Fusion échouée", err);
      },
      complete: () => (this.enCours = false),
    });
  }
}
